/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
define(["require", "exports", "azure-devops-ui/Header", "azure-devops-ui/Status", "azure-devops-ui/TooltipEx", "react"], function (require, exports, Header_1, Status_1, TooltipEx_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PageTopHeader = /** @class */ (function (_super) {
        __extends(PageTopHeader, _super);
        function PageTopHeader() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        PageTopHeader.prototype.render = function () {
            var title = this.props.title;
            return (React.createElement(Header_1.CustomHeader, { className: this.props.className },
                this._getHeaderIcon(),
                React.createElement(Header_1.HeaderTitleArea, null,
                    React.createElement(Header_1.HeaderTitleRow, null,
                        React.createElement(Header_1.HeaderTitle, { titleSize: 1 /* Large */ }, title || "")))));
        };
        PageTopHeader.prototype._getHeaderIcon = function () {
            var statusComponent = function (sProps, cName) { return React.createElement(Status_1.Status, __assign({}, sProps, { className: cName, size: "24" /* l */ })); };
            var _a = this.props, statusTooltip = _a.statusTooltip, statusProps = _a.statusProps;
            statusTooltip = statusTooltip || "";
            statusProps = statusProps ? __assign({}, statusProps, { ariaLabel: statusTooltip }) : statusProps;
            return statusProps &&
                React.createElement(Header_1.HeaderIcon, { className: "bolt-table-status-icon-large", iconProps: {
                        render: function (className) {
                            return React.createElement(TooltipEx_1.Tooltip, { text: statusTooltip, showOnFocus: true, overflowOnly: !statusTooltip },
                                React.createElement("div", { className: "flex-row" }, statusComponent(statusProps, className)));
                        }
                    } });
        };
        return PageTopHeader;
    }(React.Component));
    exports.PageTopHeader = PageTopHeader;
});
